module.exports = __webpack_public_path__ + "45fd6dc8dc9a700de4256246c60db07c.png";